import React from "react";
import AgentTable from "./AgentTable";

const AgentManagement = () => {
  return (
    <div className=" flex flex-col gap-6 p-8 bg-gray-100 min-h-screen">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold mb-4">Agent Management</h1>
      </div>
      <AgentTable />
    </div>
  );
};

export default AgentManagement;
